export enum CardState {
  ACTIVATED = 'Activated',
  NEW = 'New',
  OWNED = 'Owned',
  CHECKED_OUT = 'CheckedOut',
  READY_FOR_ACTIVATION = 'ReadyForActivation',
  READY_FOR_PURCHASE = 'ReadyForPurchase',
  GIFT_CARD = 'GiftCard',
  EMAIL_VERIFIED = 'EmailVerified',
  KYCPENDING = 'KYCPending',
  FINAL_STEP = 'FinalStep',
  TRY_AGAIN = 'TryAgain',
  CARD_NOT_USABLE = 'CardNotUsable',
  UNKNOWN = 'unknown',
}

export interface CardData {
  cardId: string;
  state: CardState;
  balance: string;
  coin: string;
  coinSymbol: string | null;
  originalAmount: string;
}

export interface RouteConfig {
  path: string;
  allowedStates: CardState[];
  component: React.ComponentType<any>;
}

export interface RouterData {
  cardID: string;
} 